<script>

export default {
  name: "PaymentAttempted",
  data () {
    return {
      code: null,
    }
  },
  created() {
    this.code = this.$route.params.code;
  },
  methods: {
  },
}
</script>

<template>
  <v-container>
    <div class="failure_container">
      <div>
        <h1 class="text-center">
          本人認証に失敗しました
        </h1>
        <h3 class="text-center mt-5">
          本人認証サービス（3Dセキュア）の設定をされていない可能性が考えられます。<br />
          ご利用のカード発行会社にお問い合わせください。<br />
        </h3>
        <h5 class="text-center ma-2 lang_lbl">{{ $t('view.3d_secure_attempted') }}</h5>
      </div>
    </div>
  </v-container>
</template>

<style scoped lang="scss">

</style>
